import httpRepository from '@core/repository/http';
import User from '@modules/user/entity';

const register = (payload: any) => {
  return httpRepository.execute({
    path: '/auth/register',
    method: 'post',
    payload,
  });
};

const forgotPassword = (payload: any) => {
  return httpRepository.execute({
    path: '/api/users/forgot_password',
    method: 'post',
    payload,
    showSuccess: false,
  });
};

const CheckRecoveryToken = (code: string) => {
  return httpRepository.execute({
    path: '/api/users/forgot/' + code,
    method: 'get',
  });
};

const updatePassword = (payload: any) => {
  return httpRepository.execute({
    path: '/api/users/ChangePassword',
    method: 'put',
    payload,
    showSuccess: false,
    showError: false,
  });
};

export interface ILoginDTO {
  userName: string;
  password: string;
}

const login = (payload: ILoginDTO) => {
  return httpRepository.execute({
    path: '/api/users/login',
    method: 'post',
    payload,
    showError: false,
    showSuccess: false,
  });
};

const logout = () => {
  return httpRepository.execute({
    path: '/api/users/logout',
    method: 'get',
    showSuccess: false,
  });
};

const resetPassword = (payload: any) => {
  return httpRepository.execute({
    path: '/api/users/forgot/' + payload.code,
    method: 'post',
    payload,
  });
};

const getProfile = () => {
  return httpRepository.execute({
    path: '/api/users/Profile',
    showSuccess: false,
    convert: res => {
      return new User(res);
    },
  });
};

const updateProfile = (payload: any) => {
  return httpRepository.execute({
    path: '/api/users/profile',
    method: 'put',
    payload,
    config: {
      isFormData: true,
    },
    convert: res => {
      return new User(res);
    },
  });
};

const updateProfileChangePassword = (payload: any) => {
  return httpRepository.execute({
    path: '/api/Profile/changePassword',
    method: 'post',
    payload,
  });
};

const uploadAvatar = (payload: any) => {
  return httpRepository.execute({
    path: 'api/users',
    method: 'put',
    payload,
  });
};

const updateProfileUser = (id: any, payload: any) => {
  return httpRepository.execute({
    path: `api/users/${id}`,
    method: 'put',
    payload,
    config: { isFormData: true },
  });
};

export default {
  register,
  login,
  logout,
  resetPassword,
  forgotPassword,
  CheckRecoveryToken,
  updatePassword,
  getProfile,
  uploadAvatar,
  updateProfile,
  updateProfileUser,
  updateProfileChangePassword,
};
